import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { defaultRootState } from "./default-root-state";

const slice = createSlice({
    name: "newComponents",
    initialState: defaultRootState.newComponents,
    reducers: {
        setNewComponents: (_state, action: PayloadAction<readonly string[]>) => {
            return new Set(action.payload);
        },
    },
});

export const newComponentReducer = slice.reducer;
export const { setNewComponents } = slice.actions;
